/*
 * Copyright (c) 2022
 * 
 * Created Date: Monday, September 26th 2022, 11:34:23 am
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

export const LanguageConst = {
    EN: 'en',
    ID: 'id'
}

export const LanguageConstArrays = [LanguageConst.EN, LanguageConst.ID]